__webpack_require__.p = "https://bs.fast.ax/build/mozzartbet-demo/1763642874/";